import Vue from 'vue'
import { app, data } from '@/categories/config/selectors'
import { getJsonData } from '@/common/utils/dom'
import { formatCurrencyJP } from '@/common/filter'
import { MaxQuantityPrice } from '@/common/types/maxQuantityPrice'

import { store } from '@/categories/store'
import App from '@/categories/App.vue'
import Categories from '@/categories/all/App.vue'
import SearchFilterCtrl from '@/categories/components/SearchFilterCtrl.vue'
import FacetsLink from '@/common/components/facets/FacetsLink.vue'
import SidebarApp from '@/categories/SidebarApp.vue'
import SortedProductSection from '@/categories/components/SortedProductSection.vue'
import CmsSection from '@/categories/components/CmsSection.vue'
import { captureMessage } from '@sentry/browser'

import './main.entry.scss'
import { initFavoriteBtn, initFavoriteBtnPopup } from '@/common/utils/favorite'
import { initProductQuickReview, initProductQuickReviewModal } from '@/common/utils/productQuickPreview'

const maxQuantityPrice: MaxQuantityPrice = getJsonData(data.maxQuantityPrice)
const initSidebarApp = () => {
  const mountEl = document.querySelector(app.sidebarMountEl)

  if (!mountEl) return

  new Vue({
    render: h =>
      h(SidebarApp, {
        props: { sharedStore: store, maxQuantityPrice }
      })
  }).$mount(mountEl)
}

const initSearchFilter = () => {
  if (window.innerWidth <= 1024) {
    const mountEl = document.querySelector(app.searchFilterMountEl)
    if (!mountEl) return

    const categoryId = mountEl.getAttribute('data-category-id')

    if (!categoryId) {
      captureMessage('Category ID not found')
      return
    }
    new Vue({
      render: h => h(SearchFilterCtrl, {
        props: { sharedStore: store, categoryId, maxQuantityPrice }
      })
    }).$mount(mountEl)
  }
}

const initApp = () => {
  const mountEl = document.querySelector(app.appMountEl)

  if (!mountEl) return

  const categoryId = Number(mountEl.getAttribute('data-category-id'))

  if (!categoryId) {
    captureMessage('Category ID not found')
    return
  }

  Vue.filter('formatCurrencyJP', formatCurrencyJP)
  new Vue({
    render: h =>
      h(App, {
        props: { sharedStore: store, categoryId, maxQuantityPrice }
      })
  }).$mount(mountEl)
}

const initCategories = () => {
  const mountEl = document.querySelector(app.allCategoriesMountEl)
  if (!mountEl) return
  new Vue({
    render: h => h(Categories, {
      props: {
        productCategories:
          getJsonData('#applicationData').product_categories || undefined
      }
    })
  }).$mount(mountEl)
}

const initFacets = () => {
  const mountEl = document.querySelector(app.facetsMountEl)
  if (!mountEl) return

  const jsonRootCategory = getJsonData(data.rootCategory)
  const categoryId = jsonRootCategory?.id || undefined
  new Vue({
    render: h => h(FacetsLink, {
      props: {
        categoryId
      }
    })
  }).$mount(mountEl)
}

const initSortedProductList = () => {
  const mountEl = document.querySelector(app.sortedProductListMountEl)

  if (!mountEl) return

  Vue.filter('formatCurrencyJP', formatCurrencyJP)

  const jsonRootCategory = getJsonData(data.rootCategory)
  const categoryId = jsonRootCategory?.id || undefined

  new Vue({
    render: h => h(SortedProductSection, {
      props: {
        categoryId
      }
    })
  }).$mount(mountEl)
}

const initCmsMagazineSection = () => {
  const mountEl = document.querySelector(app.columnMagazineSectionMountEl)
  if (!mountEl) return

  new Vue({
    render: h => h(CmsSection)
  }).$mount(mountEl)
}

initApp()
initSearchFilter()
initSidebarApp()
initCategories()
initFacets()
initSortedProductList()
initFavoriteBtn(app.favoriteButtonMountEl)
initFavoriteBtnPopup(app.favoriteButtonPopupMountEl)
initCmsMagazineSection()
initProductQuickReview(app.productQuickReview)
initProductQuickReviewModal(app.productQuickPreviewModal)
